import React, { ReactNode } from 'react';
/* eslint-disable */
interface Props {
  children?: ReactNode;
  onClick: () => void;
}

const ModifiersTableHeader: React.FC<Props> = ({
  children,
  onClick,
}: Props) => {
  return (
    <thead>
      <tr
        className="flex items-center mb-2  bg-secondary-container rounded-md"
        onClick={onClick}
      >
        {children}
      </tr>
    </thead>
  );
};

export default ModifiersTableHeader;
